export default {
    tomatoes: {
        id: 1,
        title: "SPACE TOMATOES",
        items: [{
            id: 1,
            text: "Analog Cut (mastering)",
            link: "https://www.analogcutmastering.com/"
        }, {
            id: 2,
            text: "Pheek mixing skills and advices",
            link: "https://audioservices.studio/fr/accueil-pheek-services-audio"
        }, {
            id: 3,
            text: "Pheek'corner on Facebook",
            link: "https://www.facebook.com/groups/pheekaudioservices/"
        }, {
            id: 4,
            text: "Deep grooves pressing plant",
            link: "https://deepgrooves.eu/"
        }]
    },
    asparagus: {
        id: 1,
        title: "SPACE ASPARAGUS",
        items: [{
            id: 1,
            text: "Chat noir distribution",
            link: "http://kuroneko-media.com/fr"
        },{
            id: 2,
            text: "Juliette Moal, Graphic design",
            link: "https://juliettemoal.com/"
        }]
    }
}